import { render, staticRenderFns } from "./SmbDropdown.vue?vue&type=template&id=c10b6d88&scoped=true&"
import script from "./SmbDropdown.vue?vue&type=script&lang=ts&"
export * from "./SmbDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SmbDropdown.scss?vue&type=style&index=0&id=c10b6d88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b6d88",
  null
  
)

export default component.exports